{
  "toast": {
    "unmarkedComplete": "Aula desmarcada como concluída",
    "markedComplete": "Aula marcada como concluída!",
    "statusError": "Erro ao atualizar status da aula",
    "favoriteRemoved": "Removido dos favoritos",
    "favoriteAdded": "Adicionado aos favoritos!",
    "favoriteError": "Erro ao atualizar favorito",
    "ratingSent": "Avaliação enviada!",
    "ratingError": "Erro ao enviar avaliação",
    "notesError": "Não foi possível salvar suas anotações. Tente novamente.",
    "pdfLoaded": "PDF {{title}} carregado!",
    "assignmentSubmitted": "Atividade enviada com sucesso!"
  },
  "notFound": {
    "title": "Aula não encontrada",
    "description": "Esta aula não existe ou você não tem acesso.",
    "back": "Voltar"
  },
  "progress": {
    "thisLesson": "Esta aula",
    "course": "Curso"
  },
  "sidebar": {
    "moduleLessons": "Aulas do Módulo",
    "close": "Fechar",
    "completedShort": "{{completed}}/{{total}} aulas concluídas",
    "completedLong": "{{completed}} de {{total}} aulas concluídas",
    "upNext": "Próximo"
  },
  "content": {
    "assignmentInstructions": "Instruções da Atividade",
    "supportMaterials": "Materiais de Apoio",
    "supportMaterialsDescription": "Baixe os arquivos necessários para completar esta atividade",
    "submitSolution": "Envie sua Solução",
    "submitSolutionDescription": "Faça upload dos arquivos da sua atividade concluída",
    "aboutFiles": "Sobre os Arquivos",
    "downloadFiles": "Arquivos para Download",
    "downloadFilesDescription": "Baixe os materiais e recursos desta aula"
  },
  "live": {
    "title": "Aula ao Vivo",
    "scheduledFor": "Agendada para {{date}}",
    "description": "Esta é uma aula ao vivo. Fique atento aos horários!",
    "join": "Entrar na Aula"
  },
  "info": {
    "minutes": "{{minutes}} min",
    "lessonsProgress": "{{completed}}/{{total}} aulas ({{percent}}%)"
  },
  "actions": {
    "saving": "Salvando...",
    "completed": "Concluída",
    "complete": "Concluir",
    "favorited": "Favoritado",
    "favorite": "Favoritar",
    "rated": "Avaliado",
    "rate": "Avaliar"
  },
  "rating": {
    "question": "Como você avalia esta aula?",
    "cancel": "Cancelar",
    "submit": "Enviar"
  },
  "attachments": {
    "title": "Material de apoio"
  },
  "navigation": {
    "previous": "Anterior",
    "next": "Próxima"
  },
  "notes": {
    "title": "Anotações",
    "saving": "Salvando...",
    "saved": "Salvo",
    "autosave": "Salva automaticamente",
    "placeholder": "Escreva suas anotações aqui..."
  },
  "locked": {
    "title": "Aula bloqueada",
    "description": "Você ainda não tem acesso ao curso desta aula.",
    "browse": "Ver cursos"
  },
  "player": {
    "play": "Reproduzir",
    "pause": "Pausar",
    "mute": "Silenciar",
    "unmute": "Ativar som",
    "enterFullscreen": "Tela cheia",
    "exitFullscreen": "Sair da tela cheia",
    "settings": "Configurações",
    "speed": "Velocidade",
    "normal": "Normal",
    "quality": "Qualidade",
    "pip": "Picture-in-picture",
    "rewind": "Voltar {seektime}s",
    "fastForward": "Avançar {seektime}s"
  },
  "stream": {
    "loading": "Carregando vídeo",
    "loadError": "Não foi possível carregar o vídeo.",
    "retry": "Tentar novamente",
    "playerTitle": "Player da aula",
    "resumeHere": "Continuar assistindo aqui",
    "completesByWatching": "Conclui ao assistir",
    "watchToComplete": "Assista pelo menos 90% do vídeo para concluir a aula."
  }
}
